import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getUserDetails } from "../../api/auth";
import { checkCalendlyAuthCode } from "../../api/calendly";
import { LoadingSpinner } from "../../components/loading-spinners";
import { useMutationWithDispatch } from "../../hooks/useMutationWithDispatch";
import { ROUTE_PATHS } from "../../routes/paths";
import { useAppDispatch, useAppSelector } from "../../store";

export default function Auth() {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const navigate = useNavigate();
  const { id } = useAppSelector((state) => state.auth.user);
  const { mutate: checkCalendlyAuth, isPending } = useMutationWithDispatch(
    checkCalendlyAuthCode,
    {
      onSuccess: (response) => {
        if (response?.success) {
          dispatch(getUserDetails(id));
          navigate(`${ROUTE_PATHS.SETTINGS}?type=calendly`);
        }
      },
    }
  );

  useEffect(() => {
    checkCalendlyAuth(code);
  }, [code]);

  if (isPending) return <LoadingSpinner loading={isPending} />;

  return null;
}
